import React from 'react';
import { Chip, alpha, useTheme } from '@mui/material';

/**
 * Consistent "total records" badge for admin list tables.
 * Uses theme primary colors instead of hardcoded colors, respecting dark/light mode.
 *
 * Usage:
 *   <TableCount total={totalUsers} label="users" />
 */
export default function TableCount({ total = 0, label = 'records', size = 'small', sx }) {
  const theme = useTheme();
  const n = Number(total || 0).toLocaleString('en-IN');

  return (
    <Chip
      size={size}
      label={`${n} ${label}`}
      sx={{
        fontWeight: 700,
        fontSize: '0.75rem',
        borderRadius: '6px',
        bgcolor: alpha(theme.palette.primary.main, 0.08),
        color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.16)}`,
        ...sx,
      }}
    />
  );
}
